import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { AvailabilitySchema } from "../../fragments/Availability";
import { BackdropSchema } from "../../fragments/Backdrop";
import { ContentItemSchema } from "../../fragments/ContentItem";
import { LinkItemSchema } from "../../fragments/LinkItem";
import { LogoSchema } from "../../fragments/Logo";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
import { RichTextSchema } from "../../fragments/RichText";
export const ProductMastheadBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    logo: LogoSchema.optional(),
    tagline: z.string().optional(),
    links: z.array(LinkItemSchema).optional(),
    availability: AvailabilitySchema.optional(),
    contentList: z.array(ContentItemSchema).optional(),
    linksLabel: RichTextSchema.optional(),
});
export const ProductMastheadBladeTypeValues = [
    "gameSimpleMasthead",
    "gameDetailMasthead",
    "platformSelectionMasthead",
];
export const ProductMastheadBladeTypesSchema = z.enum(ProductMastheadBladeTypeValues);
export const PlatformSelectionBladeTypes = ProductMastheadBladeTypesSchema.enum;
export const ProductMastheadBladesContractSchema = ProductMastheadBladeSchema.extend({
    type: ProductMastheadBladeTypesSchema,
});
export const GameSimpleMastheadContractSchema = ProductMastheadBladeSchema.extend({
    type: z.literal(PlatformSelectionBladeTypes.gameSimpleMasthead),
});
export const GameDetailMastheadContractSchema = ProductMastheadBladeSchema.extend({
    type: z.literal(PlatformSelectionBladeTypes.gameDetailMasthead),
});
export const PlatformSelectionMastheadBladeContractSchema = ProductMastheadBladeSchema.extend({
    type: z.literal(PlatformSelectionBladeTypes.platformSelectionMasthead),
});
//# sourceMappingURL=index.js.map